import { render, staticRenderFns } from "./SkyscrapperBanner.vue?vue&type=template&id=b4bd73b8&"
import script from "./SkyscrapperBanner.vue?vue&type=script&lang=js&"
export * from "./SkyscrapperBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports